import { Link } from 'react-router-dom';
import { useDocumentMeta } from '../lib/seo';

// Placeholder copy — intentionally neutral until the business supplies its own
// description. Replace freely; nothing here is fabricated history, awards, or
// biography (spec §94 — do not invent content).
export function About() {
  useDocumentMeta('About | Nine80 Hair Studio', 'About Nine80 Hair Studio in Concord, NC.');

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 space-y-6">
      <h1 className="text-4xl">About Nine80 Hair Studio</h1>
      <p className="text-fg-muted text-lg">
        Nine80 Hair Studio is a walk-in hair studio located at 50 Concord Commons Pl SW in Concord,
        North Carolina. We keep things simple: no appointment required for a walk-in cut — just add
        yourself to the list online or in the shop and we'll take it from there.
      </p>
      <p className="text-fg-muted text-lg">
        Prefer to book ahead instead? Appointments are handled separately through Booksy.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/check-in" className="btn-primary">
          Join the Walk-In List
        </Link>
        <Link to="/book" className="btn-secondary">
          Book an Appointment
        </Link>
      </div>
    </div>
  );
}
